"use client";

import { io } from "socket.io-client";
import { LoggerClient } from "./logger-client";
import { Socket } from "socket.io-client";
import * as crypto from 'crypto';

export let socket: Socket | null = null;

export const ack = (eventName: string, source: string, body: string) => {
    socket?.emit("ack/event", {
        event: eventName,
        source: source, 
        body: body
    })
}

export const initSocket = (token: string, userId: string, uiToken?: boolean, source = "") => {
    if (!socket) {
        const tokenObject = (uiToken) ? {
            uiToken: token
        }: {
            token: crypto.createHash('md5').update(token).digest("hex")
        }

        socket = io(process.env.NEXT_PUBLIC_CHAT_MANAGER_BACKEND_SOCKET || "http://localhost:8081", {
            query: {
                ...tokenObject,
                userId: userId
            },
            transports: ['websocket'],
            autoConnect: true,
            reconnectionDelay: 100,
            reconnectionDelayMax: 500,
            timeout: 2500,
            withCredentials: true,
        });

        setInterval(() => {
            if (socket?.connected) {
                socket.emit('keepAlive', { timestamp: Date.now() });
            }
        }, 1000);

        socket.on('reconnect', function() {
            console.log("Re-connected to the Socket.IO server!");
            ack("reconnect", source, "")
        });

        socket.on("disconnect", () => {
            console.log("Disconnection detected");
            socket?.connect()
        });

        socket.on("connect", () => {
            console.log("Connected to the Socket.IO server!");
            ack("connect", source, "")
        });

        socket.on("connect_error", (error) => {
            console.error("Connection failed:", error.message);
            LoggerClient(`User %s attempted to connect to socket which failed ${error.message}, cause: ${error.cause}`, "ERROR")
        });

        socket.io.engine.on("upgrade", (transport) => {
            console.log("Connection upgraded to WebSocket!");
            ack("upgrade", source, "")
        });

        socket.io.engine.on("upgradeError", (error) => {
            console.error("WebSocket upgrade failed:", error.message);
            LoggerClient(`User %s WebSocket upgrade failed: ${error.message}, cause: ${error.cause}`, "ERROR");
        });

        socket.on("queue-highlight-update", (d) => {
            const e = JSON.parse(d)
            if (e.state == 1) {
                ack("queue-highlight-update-success", source, `Succesfully highlighted message with id ${e.id}`)
            } else {
                ack("queue-highlight-update-error", source, `Something went wrong while highlighting message with id ${e.id}`)
            }
        })
    }
};

export const disconnectSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};